import {Field} from 'quickstart/components/controls/Field'
import {Stack} from 'quickstart/components/layout/Stack'
import {useEffect} from 'react'
import {RadioGroup as ReakitRadioGroup, useRadioState} from 'reakit/Radio'
import * as S from './styles'

export const Radio = ({label, ...rest}) => {
  const {state, value} = rest
  const checked = state === value
  return (
    <S.RadioField>
      <S.Radio {...rest} />
      <S.Label checked={checked}>{label}</S.Label>
    </S.RadioField>
  )
}

Radio.type = 'Radio' // see Field/utils.js

// exported as Radio.Group
const RadioGroup = ({
  name,
  onChange,
  options,
  value,
  spacing = 'xs',
  ...rest
}) => {
  const state = useRadioState({state: value})

  // WORKAROUND for the fact that passing a new state to the useRadioState hook
  // doesn't update.
  useEffect(() => {
    if (state.state !== value) {
      state.setState(value)
    }
  }, [state, value])

  return (
    <Field.Group as={ReakitRadioGroup} {...state} {...rest}>
      <Stack spacing={spacing}>
        {options.map(o => (
          <Radio
            key={o.value}
            name={name}
            {...o}
            {...state}
            onChange={e => {
              e.target.checked && onChange?.(o.value)
            }}
          />
        ))}
      </Stack>
    </Field.Group>
  )
}

/*
RadioGroup.propTypes = {
  options: T.optionsType.isRequired,
}
*/

Radio.Group = RadioGroup
